import BaseService from "service/base.js";

class IncidentsService {
  loadByDeviceId(deviceId) {
    return BaseService.get(`/api/incidents/device/${deviceId}`);
  }

  load() {
    return BaseService.get("/api/incidents/");
  }

  resolve(incidentId, data) {
    return BaseService.put(`/api/incidents/${incidentId}`, data);
  }

  get(incidentId) {
    return BaseService.get(`/api/incidents/${incidentId}`);
  }
}

const incidentsService = new IncidentsService();

export default incidentsService;
export { incidentsService, IncidentsService };
